import { ChangeDetectorRef, Component, inject, OnInit, Renderer2 } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { AuthServiceUser } from "../services/auth/auth.service";
import { ToastrService } from "ngx-toastr";
import { RouteTrackerService } from "../services/common-service/route-tracker.service";
// import { AuthService } from '../_services/auth.service';
// import { AlertService } from '../_services/alert.service';

@Component({
    templateUrl: "login.component.html",
    styleUrls: ["./login.component.css"],
    standalone: false
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  isPhoneNumberVerified = false;

  private readonly toastr = inject(ToastrService);
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthServiceUser,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private routeTracker: RouteTrackerService,
  ) {

  }

  ngOnInit() {

    this.loginForm = this.formBuilder.group({
      phone: ["", Validators.required], //8099592641 //9966798670
      otp: [""],
    });

    this.renderer.selectRootElement('#phone').focus();
  }

  updateOtpValidator(): void {
    if (this.isPhoneNumberVerified) {
      this.loginForm.get("otp")?.setValidators([Validators.required]);
    } else {
      this.loginForm.get("otp")?.clearValidators();
    }
    this.loginForm.get("otp")?.updateValueAndValidity();
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  tryLogin() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.submitted = false;
      return;
    }

    if (!this.isPhoneNumberVerified) {
      this.verifyPhoneNumber();
      return;
    }
    const value = {
      phone: this.f.phone.value.trim(), //8019808860
      otp: this.f.otp.value.trim(),
    };
    this.authService.login(value).subscribe({
      next: () => {
        if(this.routeTracker.getPreviousUrl()){
          this.router.navigateByUrl(this.routeTracker.getPreviousUrl());
        }else{
          this.router.navigate(["/home"]);
        }
        
        this.submitted = false;
      },
      error: (err) => {
        this.submitted = false;
        this.toastr.error(err.message, "", {
          timeOut: 3000,
        });
        console.log(err);
      },
    });
  }

  verifyPhoneNumber() {
    const value = { phone: this.f.phone.value.trim() };
    this.authService.verifyPhoneNumber(value).subscribe({
      next: () => {
        this.isPhoneNumberVerified = true;
        // this.router.navigate(['/product/all']);
        // this.setUserInStorage({person:"krishna"});
        this.cdr.detectChanges();
        this.renderer.selectRootElement('#otp').focus();
        this.submitted = false;
      },
      error: (err) => {
        console.log(err);
        this.toastr.error(err.message, "", {
          timeOut: 3000,
        });
        this.submitted = false;
      },
    });
  }

  
  sendOTP() {
    const value = { phone: this.f.phone.value.trim() };
    this.authService.sendOTPAgain(value).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.toastr.success(res.message, "", {
            timeOut: 3000,
          });
        } else {
          this.toastr.error(res.message, "", {
            timeOut: 3000,
          });
        }
      },
      error: (err) => {
        console.log(err);
        this.toastr.error(err.message, "", {
          timeOut: 3000,
        });
        this.submitted = false;
      }
    });
  }

  setUserInStorage(res) {
    if (res.user) {
      localStorage.setItem("currentUser", JSON.stringify(res.user));
    } else {
      localStorage.setItem("currentUser", JSON.stringify(res));
    }
  }

  restrictToNumbers(event: KeyboardEvent, count = 10): void {
    const input = event.target as HTMLInputElement;
    console.log(event.key);
    // Allowed non-number keys
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Tab",
      "Enter",
      "CTRL",
    ];

    const isNumberKey = event.key >= "0" && event.key <= "9";

    if (!allowedKeys.includes(event.key)) {
      if (!isNumberKey || input.value.length >= count) {
        event.preventDefault();
      }
    }
  }
}
